export class SetEnableBooking {
    static readonly type = '[Base] Set EnableBooking';
    constructor(public enabledBooking: boolean) {}
}
export class ClearState {
    public static readonly type = '[Base] Clear State';
}
